"use client";

import { Button } from "@workspace/ui/components/button";
import { ArrowRight } from "lucide-react";
import Link from "next/link";
import posthog from "posthog-js";

interface HeroLinksProps {
  primaryLink?: {
    title: string;
    href: string;
  };
  secondaryLink?: {
    title: string;
    href: string;
  };
}

export function HeroLinks({ primaryLink, secondaryLink }: HeroLinksProps) {
  const handlePrimaryClick = () => {
    posthog.capture("hero_primary_cta_clicked", {
      cta_label: primaryLink?.title,
      cta_href: primaryLink?.href,
      cta_location: "hero_section",
    });
  };

  const handleSecondaryClick = () => {
    posthog.capture("hero_secondary_cta_clicked", {
      cta_label: secondaryLink?.title,
      cta_href: secondaryLink?.href,
      cta_location: "hero_section",
    });
  };

  if (!primaryLink && !secondaryLink) {
    return null;
  }

  return (
    <div className="flex flex-col md:flex-row gap-2">
      {primaryLink && (
        <Button asChild>
          <Link href={primaryLink.href} onClick={handlePrimaryClick}>
            {primaryLink.title}
          </Link>
        </Button>
      )}
      {secondaryLink && (
        <Button variant="ghost" asChild>
          <Link href={secondaryLink.href} onClick={handleSecondaryClick}>
            {secondaryLink.title} <ArrowRight />
          </Link>
        </Button>
      )}
    </div>
  );
}
